/* eslint-ignore */
// @ts-nocheck
import styled from "styled-components";
import { Link } from "react-router-dom";

export const TooltipContainer = styled.div`
  margin-top: 8px;
  width: 100%;
  background: #97f8fb;
  padding: 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #0b29fb;
`;

export const Container = styled.div`
  display: flex;
  position: relative;
`;

export const TootipTitle = styled.span`
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: #0b29fb;
  text-align: initial;
  display: block;
  margin-bottom: 5px;
`;

export const TolltipItens = styled.span`
  text-align: initial;
`;

export const TooltipFormated = styled(Link)`
  text-decoration: underline;
  margin-left: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #0b29fb;
`;
